<form [ngClass]="{'needs-validation': !frmM.submitted, 'was-validated': frmM.submitted}"
      novalidate #frmM="ngForm" (ngSubmit)="onSalvarMovimentacao()"  >

  <section class="etapa-movimentacao mt-3" *ngIf="!exibindoResumoBeneficiamento">
    <h5 class="etapa-titulo">
      <span class="etapa-numero">1</span>
      Tipo da movimentação
    </h5>
    <div class="opcoes-movimentacao">
      <label class="opcao-movimentacao" [class.selecionada]="tipoSelecionado === 'entrada'">
        <span class="opcao-icone entrada"><i class="fas fa-arrow-down"></i></span>
        <span class="opcao-texto">
          <b>Entrada</b>
          <small>Adiciona quantidade ao estoque</small>
        </span>
        <input type="radio" name="tipoMovimentacao" value="entrada" kendoRadioButton required
               [(ngModel)]="tipoSelecionado" (change)="alterouTipo('entrada')">
      </label>

      <label class="opcao-movimentacao" [class.selecionada]="tipoSelecionado === 'saida'">
        <span class="opcao-icone saida"><i class="fas fa-arrow-up"></i></span>
        <span class="opcao-texto">
          <b>Saída</b>
          <small>Retira quantidade do estoque</small>
        </span>
        <input type="radio" name="tipoMovimentacao" value="saida" kendoRadioButton required
               [(ngModel)]="tipoSelecionado" (change)="alterouTipo('saida')">
      </label>
    </div>
  </section>

  <section class="etapa-movimentacao" *ngIf="tipoSelecionado && !exibindoResumoBeneficiamento">
    <h5 class="etapa-titulo">
      <span class="etapa-numero">2</span>
      Motivo
    </h5>
    <div class="opcoes-movimentacao">
      <label class="opcao-movimentacao opcao-motivo"
             *ngFor="let motivo of motivosDoTipo()"
             [class.selecionada]="movimentacao.motivoDaMovimentacao?.id === motivo.id">
        <span class="opcao-icone motivo"><i [ngClass]="iconeDoMotivo(motivo)"></i></span>
        <span class="opcao-texto"><b>{{motivo.descricao}}</b></span>
        <input type="radio" name="motivoMovimentacao" kendoRadioButton required
               [value]="motivo" [ngModel]="movimentacao.motivoDaMovimentacao"
               (ngModelChange)="alterouMotivo($event)">
      </label>
    </div>
  </section>

  <ng-container *ngIf="movimentacao.motivoDaMovimentacao">
    <div class="orientacao-movimentacao" *ngIf="entradaPorBenefiamento() && !exibindoResumoBeneficiamento">
      <i class="fas fa-info-circle"></i>
      <div>
        <b>Como informar a produção</b>
        <p class="mb-0 mt-1">
          Informe quantas vezes a receita foi preparada e o total realmente produzido. O consumo seguirá a composição
          cadastrada multiplicada pelas receitas preparadas; a quantidade produzida será adicionada ao estoque do item
          beneficiado
        </p>
      </div>
    </div>

    <section class="etapa-movimentacao">
      <h5 class="etapa-titulo" *ngIf="!exibindoResumoBeneficiamento">
        <span class="etapa-numero">3</span>
        Dados da movimentação
      </h5>

      <ng-container *ngIf="!exibindoResumoBeneficiamento">

      <div class="apresentacao-entrada mb-3" *ngIf="!varios && temApresentacoes(movimentacao)">
        <div class="apresentacao-entrada-cabecalho">
          <span class="apresentacao-entrada-icone"><i class="fas fa-box-open"></i></span>
          <div>
            <b>Como esta entrada foi comprada?</b>
            <small>Escolha uma unidade de compra para converter automaticamente para a unidade-base do estoque.</small>
          </div>
        </div>

        <div class="row align-items-end">
          <div class="form-group col-12 col-md-5">
            <label>Unidade de compra</label>
            <kendo-dropdownlist class="form-control" name="apresentacaoCompra"
                                [data]="apresentacoesDoItem(movimentacao)" textField="_descricaoApresentacao"
                                [defaultItem]="{id: null, _descricaoApresentacao: 'Unidade-base (' + obtenhaDescricaoUnidade(movimentacao.insumo) + ')'}"
                                [(ngModel)]="movimentacao.apresentacaoCompraInsumo"
                                (valueChange)="alterouApresentacao(movimentacao, $event)"
                                [loading]="movimentacao._carregandoApresentacoes">
            </kendo-dropdownlist>
          </div>

          <div class="form-group col-12 col-md-3" *ngIf="apresentacaoSelecionada(movimentacao)">
            <label>Quantidade comprada</label>
            <kendo-numerictextbox [min]="0.000001" [decimals]="6" [format]="'n6'"
                                  class="form-control" name="quantidadeApresentacao"
                                  [(ngModel)]="movimentacao.quantidadeApresentacao"
                                  (valueChange)="alterouQuantidadeApresentacao(movimentacao, $event)" required>
            </kendo-numerictextbox>
          </div>

          <div class="col-12 col-md-4" *ngIf="apresentacaoSelecionada(movimentacao)">
            <div class="resultado-conversao" [class.invalido]="movimentacao._erroConversaoApresentacao">
              <small>Entrada no estoque</small>
              <b>{{descricaoConversao(movimentacao)}}</b>
            </div>
          </div>
        </div>

        <small class="d-block text-danger" *ngIf="movimentacao._erroApresentacoes">
          Não foi possível carregar as unidades de compra: {{movimentacao._erroApresentacoes}}
        </small>
        <small class="d-block text-danger" *ngIf="movimentacao._erroConversaoApresentacao">
          {{movimentacao._erroConversaoApresentacao}}
        </small>
      </div>

      <div class="row mb-2" *ngIf="movimentacao.insumo && !apresentacaoSelecionada(movimentacao)">
        <div class="form-group col-12 col-md-4" *ngIf="entradaPorBenefiamento()">
          <label>Receitas preparadas</label>
          <kendo-numerictextbox id="quantidadeReceitas" [min]="0.000001" [decimals]="6" [format]="'n6'"
                                class="form-control" name="quantidadeReceitas" #quantidadeReceitas=ngModel
                                (valueChange)="alterouQuantidadeReceitas(movimentacao, $event)"
                                [(ngModel)]="movimentacao.quantidadeReceitas" required>
          </kendo-numerictextbox>
          <div class="invalid-feedback">
            <p *ngIf="quantidadeReceitas.errors?.required">Receitas preparadas é obrigatório</p>
            <p *ngIf="quantidadeReceitas.errors?.minError">Informe um valor maior que zero</p>
          </div>
        </div>

        <div class="form-group col-12 col-md-4" *ngIf="entradaPorBenefiamento()">
          <label>Rendimento esperado</label>
          <div class="form-control bg-light campo-custo-calculado">
            <ng-container *ngIf="rendimentoEsperadoDoItem(movimentacao) != null; else rendimentoIndisponivel">
              {{rendimentoEsperadoDoItem(movimentacao) | number:'1.0-3'}}
              {{obtenhaDescricaoUnidade(movimentacao.insumo)}}
            </ng-container>
            <ng-template #rendimentoIndisponivel>—</ng-template>
          </div>
        </div>

        <div class="form-group col-12" [class.col-md-4]="entradaPorBenefiamento()">
          <label>{{entradaPorBenefiamento() ? 'Quantidade produzida' : 'Quantidade'}}</label>
          <kendo-numerictextbox id="quantidade" [min]="0.001" [format]="obtenhaFormato()"
                                class="form-control" name="quantidade" #quantidade=ngModel
                                (valueChange)="alterouQuantidade(movimentacao, $event)"
                                [(ngModel)]="movimentacao.quantidade" required
                                placeholder="quantidade em {{obtenhaDescricaoUnidade(movimentacao.insumo)}}">
          </kendo-numerictextbox>

          <div class="invalid-feedback">
            <p *ngIf="quantidade.errors?.required">Quantidade é obrigatória</p>
            <p *ngIf="quantidade.errors?.minError">Quantidade deve ser maior que 0</p>
          </div>
        </div>

      </div>

  <div class="row mb-2" *ngIf="controleCustoEstoqueAtivo && !varios && entradaComCustoInformado()">
    <ng-container *ngIf="apresentacaoSelecionada(movimentacao); else custosDaUnidadeBase">
      <div class="form-group col-12 col-md-4">
        <label>{{descricaoCustoApresentacao(movimentacao)}}</label>
        <kendo-numerictextbox [min]="0" [decimals]="6" [format]="'n6'"
                              class="form-control" name="custoApresentacao"
                              [(ngModel)]="movimentacao.custoApresentacao"
                              (valueChange)="alterouCustoApresentacao(movimentacao, $event)" required>
        </kendo-numerictextbox>
      </div>
      <div class="form-group col-12 col-md-4">
        <label>Custo unitário <span>(unidade-base)</span></label>
        <div class="form-control bg-light campo-custo-calculado">
          {{movimentacao.custoUnitario == null ? '—' : (movimentacao.custoUnitario | currency:'BRL':'symbol':'1.2-6')}}
        </div>
      </div>
      <div class="form-group col-12 col-md-4">
        <label>Custo total</label>
        <kendo-numerictextbox [min]="0" [decimals]="6" [format]="'n6'"
                              class="form-control" name="custoTotalApresentacao"
                              [(ngModel)]="movimentacao.custoTotal"
                              (valueChange)="alterouCustoTotal(movimentacao, $event)" required>
        </kendo-numerictextbox>
      </div>
    </ng-container>

    <ng-template #custosDaUnidadeBase>
      <div class="form-group col-6">
        <label>Custo unitário</label>
        <kendo-numerictextbox [min]="0" [decimals]="6" [format]="'n6'"
                              class="form-control" name="custoUnitario"
                              [(ngModel)]="movimentacao.custoUnitario"
                              (valueChange)="alterouCustoUnitario(movimentacao, $event)" required>
        </kendo-numerictextbox>
      </div>
      <div class="form-group col-6">
        <label>Custo total</label>
        <kendo-numerictextbox [min]="0" [decimals]="6" [format]="'n6'"
                              class="form-control" name="custoTotal"
                              [(ngModel)]="movimentacao.custoTotal"
                              (valueChange)="alterouCustoTotal(movimentacao, $event)" required>
        </kendo-numerictextbox>
      </div>
    </ng-template>
  </div>

  <div class="row mb-2" *ngIf="controleCustoEstoqueAtivo && !varios && saidaComCustoCalculado()">
    <div class="form-group col-6">
      <label>Custo médio vigente</label>
      <div class="form-control bg-light">
        {{custoMedioAtual(movimentacao) == null ? 'Desconhecido' : (custoMedioAtual(movimentacao) | currency:'BRL')}}
      </div>
    </div>
    <div class="form-group col-6">
      <label>Custo total previsto</label>
      <div class="form-control bg-light">
        {{custoTotalPrevisto(movimentacao) == null ? '—' : (custoTotalPrevisto(movimentacao) | currency:'BRL')}}
      </div>
    </div>
    <div class="col-12 text-danger" *ngIf="custoDesconhecido(movimentacao)">
      O estoque está sem custo conhecido; a saída será bloqueada até que o custo seja informado.
    </div>
  </div>

  <div class="alert alert-info" *ngIf="carregandoPreviaBeneficiamento">
    <i class="k-icon k-i-loading mr-1"></i> Calculando o resultado do beneficiamento...
  </div>

  <div class="alert alert-danger" *ngIf="erroPreviaBeneficiamento">
    {{erroPreviaBeneficiamento}}
  </div>

      </ng-container>

  <h5 class="etapa-titulo" *ngIf="exibindoResumoBeneficiamento">
    <span class="etapa-numero">4</span>
    Confirmação da produção
  </h5>

  <section class="resultado-previa"
           *ngIf="exibindoResumoBeneficiamento && previaBeneficiamento">
    <header class="resultado-previa-cabecalho">
      <span class="resultado-previa-icone"><i class="fas fa-calculator"></i></span>
      <div>
        <h5>Resultado depois de salvar </h5>
        <small>Confira como ficarão o estoque e o custo desta produção.</small>
      </div>
    </header>

    <div class="resultado-previa-item"
         *ngFor="let item of previaBeneficiamento.itens; let ultimo = last"
         [class.ultimo]="ultimo">
      <div class="resultado-previa-nome" *ngIf="varios">
        <i class="fas fa-box mr-1"></i> {{item.insumo?.nome}}
      </div>

      <div class="resultado-rendimento"
           [class.perda]="item.variacaoQuantidade < 0"
           [class.ganho]="item.variacaoQuantidade > 0">
        <div>
          <span>Receitas preparadas</span>
          <b>{{receitasPreparadasDaPrevia(item) | number:'1.0-6'}}</b>
        </div>
        <div>
          <span>Rendimento esperado</span>
          <b>{{rendimentoEsperadoDaPrevia(item) | number:'1.0-3'}} {{obtenhaDescricaoUnidade(item.insumo)}}</b>
        </div>
        <div>
          <span>Rendimento real</span>
          <b>{{item.quantidadeProduzida | number:'1.0-3'}} {{obtenhaDescricaoUnidade(item.insumo)}}</b>
        </div>
        <div>
          <span>Variação</span>
          <b>{{item.variacaoQuantidade > 0 ? '+' : ''}}{{item.variacaoQuantidade | number:'1.0-3'}}
            {{obtenhaDescricaoUnidade(item.insumo)}}
            ({{item.variacaoPercentual > 0 ? '+' : ''}}{{item.variacaoPercentual | number:'1.0-2'}}%)</b>
        </div>
      </div>

      <div class="fluxo-estoque">
        <div class="fluxo-estoque-valor">
          <span>Estoque atual</span>
          <b>{{item.quantidadeEstoqueAtual | number:'1.0-3'}} {{obtenhaDescricaoUnidade(item.insumo)}}</b>
        </div>
        <i class="fas fa-arrow-right fluxo-estoque-seta"></i>
        <div class="fluxo-estoque-valor entrada">
          <span>Entrada produzida</span>
          <b>+ {{item.quantidadeProduzida | number:'1.0-3'}} {{obtenhaDescricaoUnidade(item.insumo)}}</b>
        </div>
        <i class="fas fa-arrow-right fluxo-estoque-seta"></i>
        <div class="fluxo-estoque-valor resultado">
          <span>Estoque depois de salvar</span>
          <b>{{item.quantidadeEstoqueResultante | number:'1.0-3'}} {{obtenhaDescricaoUnidade(item.insumo)}}</b>
        </div>
      </div>

      <div class="resultado-custos" *ngIf="item.custoMedioResultante != null">
        <div>
          <span>Custo médio atual</span>
          <b>{{item.custoMedioAtual == null ? 'Desconhecido' : (item.custoMedioAtual | currency:'BRL':'symbol':'1.2-6')}}</b>
        </div>
        <div class="resultado-custo-final">
          <span>Custo médio depois de salvar</span>
          <b>{{item.custoMedioResultante | currency:'BRL':'symbol':'1.2-6'}}</b>
        </div>
      </div>

      <div class="resultado-receita">
        <div class="resultado-receita-titulo">
          <span class="resultado-receita-icone"><i class="fas fa-utensils"></i></span>
          <div>
            <b>Receitas aplicadas: {{receitasPreparadasDaPrevia(item) | number:'1.0-6'}}</b>
            <small>
              Produção real: {{item.quantidadeProduzida | number:'1.0-3'}} {{obtenhaDescricaoUnidade(item.insumo)}} ·
              rendimento cadastrado por receita: {{item.rendimentoReceita | number:'1.0-3'}} {{obtenhaDescricaoUnidade(item.insumo)}}
            </small>
          </div>
        </div>
        <p>Consumo previsto dos ingredientes</p>
        <div class="table-responsive">
          <table class="table table-sm mb-0 resultado-ingredientes-grid">
            <thead>
              <tr>
                <th>Ingrediente</th>
                <th>Saldo atual</th>
                <th>Saldo consumido</th>
                <th>Saldo depois</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let ingrediente of item.ingredientes"
                  [class.ingrediente-insuficiente]="!ingrediente.saldoSuficiente">
                <td>
                  {{ingrediente.nome}}
                  <i *ngIf="!ingrediente.saldoSuficiente"
                     class="fas fa-exclamation-triangle ml-1" title="Saldo insuficiente"></i>
                </td>
                <td>{{ingrediente.saldoAtual | number:'1.0-3'}}<ng-container *ngIf="ingrediente.unidade"> {{ingrediente.unidade}}</ng-container></td>
                <td>- {{ingrediente.quantidadeConsumida | number:'1.0-3'}}<ng-container *ngIf="ingrediente.unidade"> {{ingrediente.unidade}}</ng-container></td>
                <td>{{ingrediente.saldoDepois | number:'1.0-3'}}<ng-container *ngIf="ingrediente.unidade"> {{ingrediente.unidade}}</ng-container></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="alert alert-danger mx-3" *ngIf="previaBeneficiamento.podeConfirmar !== true">
      <i class="fas fa-ban mr-1"></i>
      Movimentação bloqueada. Reponha o saldo dos ingredientes destacados ou volte e ajuste as receitas preparadas.
    </div>

    <footer class="resultado-previa-rodape">
      <i class="fas fa-info-circle mr-1"></i>
      O resultado definitivo será recalculado ao salvar.
    </footer>
  </section>

      <ng-container *ngIf="!exibindoResumoBeneficiamento">

  <div class="row mb-2">
    <div class="form-group col-12">
      <label for="horario">Data de movimentação</label>
      <div class="input-group">
        <kendo-datepicker [(ngModel)]="movimentacao.horario" id="horario"
                          name="horario" #horario=ngModel [format]="'dd/MM/yyyy HH:mm'"
                          class="form-control k-display-inline-block" required>
          <kendo-datepicker-messages today="Hoje" toggle="Alterar data"></kendo-datepicker-messages>
        </kendo-datepicker>

        <div class="invalid-feedback">
          <p *ngIf="horario.errors?.required">Data é obrigatória</p>
        </div>
      </div>
    </div>
  </div>

  <div class="row mb-2 campo-observacao">
    <div class="form-group  col-12">
      <label>Observação <span class="text-muted">(opcional)</span></label>

      <textarea type="text" class="form-control" autocomplete="off" maxlength="255"
                id="observacao" name="observacao" [(ngModel)]="movimentacao.observacao" #observacao="ngModel"
                placeholder="Inclua uma observação se desejar" value=""  >
                 </textarea>
      <small class="contador-caracteres">{{(movimentacao.observacao || '').length}}/255</small>
    </div>
  </div>

  <div class="row mb-2" *ngIf="exigeJustificativa()">
    <div class="form-group col-12">
      <label>Justificativa</label>
      <textarea class="form-control" maxlength="500" name="justificativa"
                [(ngModel)]="movimentacao.justificativa" required
                placeholder="Explique a perda ou o ajuste realizado"></textarea>
    </div>
  </div>

  <div *ngIf="varios">
    <kendo-grid    [data]="movimentacoes"  >
      <kendo-grid-messages
        pagerPage="Página"
        pagerOf="de"
        pagerItems="itens"
        noRecords="Nenhum grupo cadastrado"
        loading="Carregando"
        pagerItemsPerPage="ítems por página"
      >
      </kendo-grid-messages>

      <kendo-grid-column    [width]="30">
        <ng-template kendoGridCellTemplate let-rowIndex="rowIndex" let-dataItem>
          <span [class.removido]="dataItem.removido">         {{rowIndex + 1}}</span>

        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column   title="Insumo" [width]="300">
        <ng-template kendoGridGroupHeaderTemplate let-value="value">
            {{entradaPorBenefiamento() ? 'Receita' : 'Insumo'}}
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <app-selecionar-insumo [exbirLabel]="false" [selectedItem]="dataItem" [indice]="rowIndex" [formClass]="''"
                                 (onAlterou)="alterouInsumoDaMovimentacao(dataItem)">

          </app-selecionar-insumo>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Unidade de compra" [width]="230"
                         *ngIf="tipoMovimentacao() === 'entrada' && !entradaPorBenefiamento()">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <kendo-dropdownlist *ngIf="temApresentacoes(dataItem)" class="form-control"
                              name="apresentacaoCompra{{rowIndex}}"
                              [data]="apresentacoesDoItem(dataItem)" textField="_descricaoApresentacao"
                              [defaultItem]="{id: null, _descricaoApresentacao: 'Unidade-base'}"
                              [(ngModel)]="dataItem.apresentacaoCompraInsumo"
                              (valueChange)="alterouApresentacao(dataItem, $event)"
                              [loading]="dataItem._carregandoApresentacoes">
          </kendo-dropdownlist>
          <span class="text-muted" *ngIf="!temApresentacoes(dataItem)">Unidade-base</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Receitas preparadas" [width]="175" *ngIf="entradaPorBenefiamento()">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <kendo-numerictextbox [min]="0.000001" [decimals]="6" [format]="'n6'"
                                class="form-control" name="quantidadeReceitas{{rowIndex}}"
                                [(ngModel)]="dataItem.quantidadeReceitas"
                                (valueChange)="alterouQuantidadeReceitas(dataItem, $event)" required>
          </kendo-numerictextbox>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Rendimento esperado" [width]="175" *ngIf="entradaPorBenefiamento()">
        <ng-template kendoGridCellTemplate let-dataItem>
          <strong *ngIf="rendimentoEsperadoDoItem(dataItem) != null">
            {{rendimentoEsperadoDoItem(dataItem) | number:'1.0-3'}}
            {{obtenhaDescricaoUnidade(dataItem.insumo)}}
          </strong>
          <span *ngIf="rendimentoEsperadoDoItem(dataItem) == null">—</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column [title]="entradaPorBenefiamento() ? 'Quantidade produzida' : 'Qtde'" [width]="200">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <div class="form-group mb-0" *ngIf="!apresentacaoSelecionada(dataItem)">
            <kendo-numerictextbox   [min]="0.001"   [format]="obtenhaFormatoDoInsumo(dataItem.insumo)"
                                  class="form-control" name="quantidade{{rowIndex}}" #quantidade=ngModel
                                  (valueChange)="alterouQuantidade(dataItem, $event)"
                                  [(ngModel)]="dataItem.quantidade" required
                                  placeholder="quantidade em {{obtenhaDescricaoUnidade(dataItem.insumo)}}">
            </kendo-numerictextbox>
          </div>
          <div class="form-group mb-0" *ngIf="apresentacaoSelecionada(dataItem)">
            <kendo-numerictextbox [min]="0.000001" [decimals]="6" [format]="'n6'"
                                  class="form-control" name="quantidadeApresentacao{{rowIndex}}"
                                  [(ngModel)]="dataItem.quantidadeApresentacao"
                                  (valueChange)="alterouQuantidadeApresentacao(dataItem, $event)" required>
            </kendo-numerictextbox>
            <small class="d-block text-muted mt-1" *ngIf="!dataItem._erroConversaoApresentacao">
              {{descricaoConversao(dataItem)}}
            </small>
            <small class="d-block text-danger mt-1" *ngIf="dataItem._erroConversaoApresentacao">
              {{dataItem._erroConversaoApresentacao}}
            </small>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Custo da unidade de compra" [width]="210" *ngIf="entradaComCustoInformado()">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <div *ngIf="apresentacaoSelecionada(dataItem)">
            <small class="d-block text-muted mb-1">{{descricaoCustoApresentacao(dataItem)}}</small>
            <kendo-numerictextbox [min]="0" [decimals]="6" [format]="'n6'"
                                  class="form-control" name="custoApresentacao{{rowIndex}}"
                                  [(ngModel)]="dataItem.custoApresentacao"
                                  (valueChange)="alterouCustoApresentacao(dataItem, $event)" required>
            </kendo-numerictextbox>
          </div>
          <span class="text-muted" *ngIf="!apresentacaoSelecionada(dataItem)">—</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Custo unit." [width]="170" *ngIf="entradaComCustoInformado()">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <kendo-numerictextbox *ngIf="!apresentacaoSelecionada(dataItem)"
                                [min]="0" [decimals]="6" [format]="'n6'"
                                class="form-control" name="custoUnitario{{rowIndex}}"
                                [(ngModel)]="dataItem.custoUnitario"
                                (valueChange)="alterouCustoUnitario(dataItem, $event)" required>
          </kendo-numerictextbox>
          <div class="form-control bg-light campo-custo-calculado"
               *ngIf="apresentacaoSelecionada(dataItem)">
            {{dataItem.custoUnitario == null ? '—' : (dataItem.custoUnitario | currency:'BRL':'symbol':'1.2-6')}}
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Custo total" [width]="170" *ngIf="entradaComCustoInformado()">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <kendo-numerictextbox *ngIf="!apresentacaoSelecionada(dataItem)"
                                [min]="0" [decimals]="6" [format]="'n6'"
                                class="form-control" name="custoTotal{{rowIndex}}"
                                [(ngModel)]="dataItem.custoTotal"
                                (valueChange)="alterouCustoTotal(dataItem, $event)" required>
          </kendo-numerictextbox>
          <kendo-numerictextbox *ngIf="apresentacaoSelecionada(dataItem)"
                                [min]="0" [decimals]="6" [format]="'n6'"
                                class="form-control" name="custoTotalApresentacao{{rowIndex}}"
                                [(ngModel)]="dataItem.custoTotal"
                                (valueChange)="alterouCustoTotal(dataItem, $event)" required>
          </kendo-numerictextbox>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Custo calculado" [width]="190" *ngIf="saidaComCustoCalculado()">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span *ngIf="!custoDesconhecido(dataItem)">
            {{custoMedioAtual(dataItem) | currency:'BRL'}} / {{custoTotalPrevisto(dataItem) | currency:'BRL'}}
          </span>
          <span class="text-danger" *ngIf="custoDesconhecido(dataItem)">Custo desconhecido</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-command-column title=""  [class]="{'comandos': true}" [width]="100">
        <ng-template kendoGridCellTemplate let-isNew="isNew" let-item let-rowIndex="rowIndex">
          <button kendoGridRemoveCommand kendoTooltip title="remover" (click)="removaMovimentacao(rowIndex)"   >
            <i class="fa fa-trash text-danger"></i>
          </button>
        </ng-template>

      </kendo-grid-command-column>

    </kendo-grid>

    <button class="btn btn-outline-blue btn-xs mb-3 mt-2" type="button" (click)="novaMovimentacao()">
      <b> <i class="fe-plus"></i> Adicionar</b> </button>

  </div>

      </ng-container>

    </section>
  </ng-container>

  <div class="alert alert-info" *ngIf="resultadoBeneficiamento">
    Lote de beneficiamento <b>#{{resultadoBeneficiamento.beneficiamento?.id}}</b> processado.
    <ng-container *ngIf="resultadoBeneficiamento.custoTotal != null">
      Custo transferido: <b>{{resultadoBeneficiamento.custoTotal | currency:'BRL'}}</b> total,
      média resultante <b>{{resultadoBeneficiamento.custoMedioResultante | currency:'BRL'}}</b>.
    </ng-container>
  </div>


  <div class="modal-footer">

    <p  *ngIf="mensagemErro" class="text-danger ">
      <i class="mdi mdi-check-all mr-1"></i> {{mensagemErro}}
    </p>

    <button type="button" class="btn btn-light waves-effect"
            *ngIf="exibindoResumoBeneficiamento"
            (click)="volteDoResumoDaProducao()">
      <i class="fas fa-arrow-left mr-1"></i>Voltar
    </button>

    <button type="button" class="btn btn-light waves-effect" data-dismiss="modal"
            (click)="canceleMovimentacao()">Cancelar</button>

    <button type="submit" class="btn btn-success waves-effect waves-light"
            [disabled]="salvando || carregandoStatusControleCusto || carregandoPreviaBeneficiamento || possuiErroApresentacao() || !tipoSelecionado || !movimentacao.motivoDaMovimentacao || (exibindoResumoBeneficiamento && previaBeneficiamento?.podeConfirmar !== true)">
      <i *ngIf="salvando" class="k-icon k-i-loading"></i>
      <i *ngIf="!salvando && entradaPorBenefiamento() && !exibindoResumoBeneficiamento"
         class="fas fa-arrow-right mr-1"></i>
      <i *ngIf="!salvando && (!entradaPorBenefiamento() || exibindoResumoBeneficiamento)"
         class="fas fa-check mr-1"></i>
      <ng-container *ngIf="entradaPorBenefiamento(); else salvarMovimentacao">
        {{exibindoResumoBeneficiamento ? 'Confirmar movimentação' : 'Ir para resumo da produção'}}
      </ng-container>
      <ng-template #salvarMovimentacao>Salvar movimentação</ng-template>
    </button>
  </div>

</form>
